/* eslint-disable no-unused-vars */
import { API_NOTIFICATION } from 'configs/api'
import networkAdapter from 'utilities/networkAdapter'

export enum OS_TYPE {
  IOS = 1,
  ANDROID = 2,
  WEB = 3,
}

export const apiGetNotification = async (params: {app_id:string, page:number, per_page: number, os_type: OS_TYPE }) => {
  const notify = await networkAdapter.get(API_NOTIFICATION, params)
  return notify.data
}
